import * as React from 'react';
function SvgTwoWayConvo() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.92 6.37a3.06 3.06 0 00-1.42 2.7c0 .61.13 1.11.33 1.52.2.41.37.95.25 1.52L5.9 13l2.44-.42c.28-.05.55-.04.81 0 .36.05.73.07 1.1.07 1.23 0 2.45-.28 3.33-.87A3.06 3.06 0 0015 9.08c0-1.29-.57-2.15-1.42-2.71a6.14 6.14 0 00-3.33-.87c-1.23 0-2.45.28-3.33.87zm-.83-1.25A7.63 7.63 0 0110.25 4c1.43 0 2.96.32 4.16 1.12a4.55 4.55 0 012.09 3.96c0 1.83-.85 3.13-2.09 3.95a7.62 7.62 0 01-4.16 1.13 9.2 9.2 0 01-1.32-.1 1.11 1.11 0 00-.34 0l-2.43.42c-.94.16-1.98-.6-1.75-1.7l.2-.97c.02-.13 0-.3-.12-.55A4.82 4.82 0 014 9.08c0-1.83.85-3.14 2.09-3.96z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.58 11.37a3.06 3.06 0 011.42 2.7c0 .61-.13 1.11-.33 1.52-.2.41-.37.95-.25 1.52l.18.89-2.44-.42a2.6 2.6 0 00-.81 0 7.7 7.7 0 01-1.1.08 6.14 6.14 0 01-3.33-.88 3.06 3.06 0 01-1.42-2.7c0-1.29.57-2.15 1.42-2.71.88-.59 2.1-.87 3.33-.87s2.45.28 3.33.87zm.83-1.25A7.63 7.63 0 0013.25 9c-1.43 0-2.96.32-4.16 1.12A4.55 4.55 0 007 14.08c0 1.83.85 3.13 2.09 3.95 1.2.8 2.73 1.13 4.16 1.13.44 0 .88-.04 1.32-.1.12-.02.24-.02.34 0l2.43.42c.94.16 1.98-.6 1.75-1.7l-.2-.97c-.02-.13 0-.3.12-.55.32-.63.49-1.36.49-2.18 0-1.83-.85-3.14-2.09-3.96z",
    clipRule: "evenodd"
  }));
}
export default SvgTwoWayConvo;